import { z } from "zod";

import { LocationData } from "../../../../models/LocationData";

export const schema = z.object({
  websiteUri: z.string().trim().optional().or(z.literal(""))
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (data: LocationData): Schema => {
  return {
    websiteUri: data.website_url || ""
  };
};
